var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 37,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M0 37h169V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-70 -60)",
    filter: "url(#a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.412 60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.097 5.751h18.07L78 0H55.91c-4.258 0-7.51 1.108-9.664 3.294C44.091 5.48 43 8.777 43 13.094V23.91C43 32.596 47.344 37 55.911 37H78l-2.835-5.751H57.092c-2.426 0-4.258-.61-5.445-1.815-1.188-1.204-1.79-3.063-1.79-5.526V13.092c0-4.94 2.368-7.34 7.24-7.34",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    mask: "url(#c)",
    d: "M0 21h12v-6H0zM20 21h12v-6H20zM0 6h32.164L35 0H0zM0 31v6h35l-2.836-6zM93.11 15.64V0H86v37h7.11V21.378H101V15.64zM116.267 15.634H109v5.737h7.267V37l6.733-.01V0h-6.733zM162.088 15.666h-8.16v5.73h8.16v2.512c-.002 4.941-2.39 7.343-7.303 7.343h-9.565c-4.915 0-7.304-2.402-7.304-7.343v-2.512h8.16v-5.73h-8.16v-2.574c.002-4.94 2.39-7.343 7.304-7.343h9.565c4.914 0 7.303 2.402 7.303 7.343v2.574zM155.978 0h-11.957C135.381 0 131 4.405 131 13.092v10.816C131 32.595 135.381 37 144.021 37h11.958C164.619 37 169 32.595 169 23.908V13.092C169 4.405 164.619 0 155.979 0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.c36ead0a59af1f16bd2c4c9529707390.svg";
export { ForwardRef as ReactComponent };